import $ from 'jquery';
import noScroll from '../scripts/noScroll';
import breakpoint from '../scripts/breakpoint';

$.addInit(function(context){
	var base = '.i-head';
	$(base, context).each(function(){
		var component = $(this);
		var scrollPos = 0;
		var delta = 5;
		var top = $('.l-main').offset().top;

		function scrollOnMob() {
			var currentScrollPos = $(this).scrollTop();

			if(Math.abs(scrollPos - currentScrollPos) <= delta)
				return;

			component.toggleClass('m-unpinned', !(currentScrollPos > scrollPos || currentScrollPos <= 103));

			scrollPos = currentScrollPos;
		}

		function scrollOnDesktop() {
			var currentScrollPos = $(this).scrollTop();

			component.toggleClass("m-activeScrolled", currentScrollPos > top);
		}

		breakpoint(null, 'lg')
			.onmatch(function(){
				$(window).on('scroll', scrollOnMob);
				$(window).off('scroll', scrollOnDesktop);
			})
			.onmismatch(function(){
				component.removeClass("m-unpinned");
				$(window).off('scroll', scrollOnMob);
				$(window).on('scroll', scrollOnDesktop);
			});


		var scan = component.find('.b-head-scan');
		var dropdown = scan.siblings('.b-head-dropdown');
		var isActive = false;
		var overlay = $('<div>', {
			'class': 'b-overlay'
		})

		function setActive(value) {
			scan.toggleClass('m-active', value);
			dropdown.toggleClass('m-active', value);
			$(document)[value ? 'on' : 'off']('click', closeHandler);

			if (value) {
				overlay.appendTo('body')
			} else {
				overlay.detach()
			};

			isActive = value;
		}

		function toggleHandler(e) {
			e.preventDefault();

			if (!scan.hasClass('m-active')) {
				setTimeout(function() {
					setActive(true);
				});
			} else {
				setTimeout(function() {
					setActive(false);
				});
			}
		}

		function closeHandler(e) {
			if ($(e.target).closest(dropdown).length === 0) {
				setActive(false);
			}
		}

		scan.on('click', toggleHandler);
	});
});


//////////////////
// WEBPACK FOOTER
// ./src/components/i-head.js
// module id = 56
// module chunks = 0